var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll.self",
          value: _vm.onScroll,
          expression: "onScroll",
          modifiers: { self: true },
        },
      ],
      staticClass: "overflow-y-auto",
      attrs: { "max-height": "600" },
    },
    [
      _vm._l(_vm.notifications.data, function (item, idx) {
        return _c(
          "v-list-item",
          {
            key: idx,
            class: {
              unread: !item.interacted_at,
              "cursor-pointer": !item.interacted_at,
            },
            on: {
              click: function ($event) {
                return _vm.handleClick(item)
              },
            },
          },
          [
            _c(
              "v-list-item-avatar",
              [_c("v-img", { attrs: { src: item.data.image } })],
              1
            ),
            _vm._v(" "),
            _c(
              "v-list-item-content",
              [
                _c(
                  "v-list-item-title",
                  {
                    staticClass: "ws-wrap",
                    class: {
                      "soli-grey": item.interacted_at,
                    },
                  },
                  [_vm._v(_vm._s(item.data.title))]
                ),
                _vm._v(" "),
                _c("v-list-item-subtitle", { staticClass: "ws-wrap" }, [
                  _vm._v(_vm._s(item.data.subtitle)),
                ]),
                _c("small", { staticClass: "accent--text" }, [
                  _vm._v(_vm._s(_vm.moment(item.created_at).fromNow())),
                ]),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto my-3",
            attrs: { type: "list-item-avatar-three-line@3" },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }